import type { ResearchExecutionMode } from '@/lib/research-assistant/runtime/run-controller';

export interface ExecutionDirective {
  executionMode: ResearchExecutionMode;
  message: string;
  command: 'select_mode' | 'cancel_run' | null;
}

const LEADING_MODE_COMMAND = /^\/(plan|goal)(?=\s|$)(?:\s+([\s\S]*))?$/i;

export function resolveExecutionDirective(
  text: string,
  selectedMode: ResearchExecutionMode = 'standard'
): ExecutionDirective {
  const trimmed = text.trim();
  const match = trimmed.match(LEADING_MODE_COMMAND);
  if (!match) {
    return { executionMode: selectedMode, message: trimmed, command: null };
  }
  const executionMode = match[1].toLowerCase() as 'plan' | 'goal';
  const remainder = (match[2] || '').trim();
  if (!remainder) return { executionMode, message: '', command: 'select_mode' };
  if (remainder.toLowerCase() === 'cancel') {
    return { executionMode, message: '', command: 'cancel_run' };
  }
  return { executionMode, message: remainder, command: null };
}
